import React from 'react'
import img from '../assets/images/target038.png'

export default function Section19() {
    return (
        <div className="section">
            <div className="box-container">
                <div className="heading">Toolbar Icons</div>
                <div className="body">
                    <img src={img} alt="icons" />
                    <div className="last-box-content">
                        <p>Action</p>
                        <p>Copy</p>
                        <p>Data</p>
                        <p>Date</p>
                        <p>Delete</p>
                        <p>Email</p>
                        <p>help</p>
                        <p>Import</p>
                        <p>Info</p>
                        <p>Manage</p>
                        <p>Mark All</p>
                        <p>Notes</p>
                        <p>Settings</p>
                        <p>Target</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
